<script lang="ts" setup>
import type { MenuItem } from '~/types/menus'

defineProps<{
  items: MenuItem[]
}>()
</script>

<template>
  <ul class="left-side-menu">
    <li v-for="x in items" :key="x.path" class="left-side-menu__item">
      <a
        v-if="x.path && x.isUsualLink"
        class="left-side-menu__title-wrapper inline-flex items-center"
        :href="x.path"
        rel="noopener noreferrer"
        target="_blank"
      >
        <SvgIcon v-if="x.icon" class="left-side-menu__icon" :name="x.icon" />

        <span class="left-side-menu__title">{{ x.name }}</span>
      </a>
      <NuxtLink v-else class="left-side-menu__title-wrapper inline-flex items-center" :to="x.path">
        <SvgIcon v-if="x.icon" class="left-side-menu__icon" :name="x.icon" />

        <span class="left-side-menu__title">{{ x.name }}</span>
      </NuxtLink>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.left-side-menu {
  @media screen and (max-width: 1020px) {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -8px;
  }

  &__icon {
    margin-right: 8px;
  }

  &__item {
    font-size: 18px;

    @media screen and (max-width: 1020px) {
      margin: 0 24px 8px 0;

      &:last-child {
        margin-right: 0;
      }
    }

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__title {
    line-height: 1.2em;
  }

  &__title-wrapper {
    color: inherit;

    &:hover,
    &.nuxt-link-exact-active {
      color: variables.$main-green-color;
    }

    &.router-link-exact-active {
      text-decoration: underline;
    }
  }
}
</style>
